import { render, staticRenderFns } from "./Dashboard_9.vue?vue&type=template&id=ea42f8d6&"
var script = {}
import style0 from "./Dashboard_9.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports